(() => {
  const DESCRIPTION_SELECTOR = '.product__description.rte';

  function addDescriptionStyles() {
    if (document.getElementById('wnw-description-style')) return;

    const style = document.createElement('style');
    style.id = 'wnw-description-style';

    style.textContent = `
      .wnw-details-heading {
        margin: 26px 0 14px !important;
        color: #333 !important;
        font-size: 17px !important;
        line-height: 1.3 !important;
        font-weight: 700 !important;
        letter-spacing: 0.2px !important;
      }

      .wnw-details-list {
        margin: 0 0 22px !important;
        padding-left: 20px !important;
        color: #555 !important;
      }

      .wnw-details-list li {
        margin: 4px 0 !important;
        padding: 0 !important;
        line-height: 1.55 !important;
      }

      .wnw-details-list strong {
        color: #333 !important;
        font-weight: 700 !important;
      }

      .wnw-product-note {
        margin: 20px 0 0 !important;
        padding: 14px 16px !important;
        border-left: 4px solid #f5820b !important;
        border-radius: 6px !important;
        background: #fff7ef !important;
        color: #444 !important;
        line-height: 1.65 !important;
      }

      .wnw-product-note strong {
        color: #222 !important;
        font-weight: 800 !important;
      }

      @media screen and (max-width: 749px) {
        .wnw-details-heading {
          font-size: 16px !important;
        }

        .wnw-product-note {
          padding: 12px 14px !important;
        }
      }
    `;

    document.head.appendChild(style);
  }

  function cleanText(text) {
    return (text || '')
      .replace(/\u00a0/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  function getElementLines(element) {
    const clone = element.cloneNode(true);

    clone.querySelectorAll('br').forEach((br) => {
      br.replaceWith(document.createTextNode('\n'));
    });

    return (clone.textContent || '')
      .replace(/\u00a0/g, ' ')
      .split(/\n+/)
      .map(cleanText)
      .filter(Boolean);
  }

  function formatDescription(description) {
    if (!description) return;

    if (description.dataset.wnwFormatted === 'true') return;

    const children = Array.from(description.children);

    const oldHeading = children.find((element) => {
      return cleanText(element.textContent).toUpperCase() === 'PRODUCT DETAILS';
    });

    if (!oldHeading) return;

    const newHeading = document.createElement('h3');
    newHeading.className = 'wnw-details-heading';
    newHeading.textContent = 'PRODUCT DETAILS';

    oldHeading.replaceWith(newHeading);

    const details = [];
    let noteText = '';
    let reachedDetails = false;

    Array.from(description.children).forEach((element) => {
      if (element === newHeading) {
        reachedDetails = true;
        return;
      }

      if (!reachedDetails) return;

      /* Customer Reviews ya kisi review widget ko kabhi touch nahi karna */
      const reviewElement =
        element.matches('[class*="review"], [id*="review"]') ||
        element.querySelector('[class*="review"], [id*="review"]');

      if (reviewElement) return;

      const lines = getElementLines(element);
      if (!lines.length) return;

      const remainingLines = [];
      let matchedSomething = false;

      lines.forEach((line) => {
        const detailMatch = line.match(
          /^(Shoe Size|Size|Color|Condition)\s*:\s*(.+)$/i
        );

        if (detailMatch) {
          let label = detailMatch[1];

          if (/^(shoe\s*)?size$/i.test(label)) label = 'Size';
          if (/color/i.test(label)) label = 'Color';
          if (/condition/i.test(label)) label = 'Condition';

          details.push({
            label,
            value: cleanText(detailMatch[2])
          });

          matchedSomething = true;
          return;
        }

        const noteMatch = line.match(/^Please note\s*:\s*(.+)$/i);

        if (noteMatch) {
          noteText = cleanText(noteMatch[1]);
          matchedSomething = true;
          return;
        }

        remainingLines.push(line);
      });

      if (!matchedSomething) return;

      if (remainingLines.length) {
        element.textContent = remainingLines.join(' ');
      } else {
        element.remove();
      }
    });

    let lastInsertedElement = newHeading;

    if (details.length) {
      const list = document.createElement('ul');
      list.className = 'wnw-details-list';

      details.forEach((detail) => {
        const item = document.createElement('li');
        const label = document.createElement('strong');

        label.textContent = `${detail.label}: `;

        item.appendChild(label);
        item.appendChild(document.createTextNode(detail.value));
        list.appendChild(item);
      });

      newHeading.insertAdjacentElement('afterend', list);
      lastInsertedElement = list;
    }

    if (noteText) {
      const note = document.createElement('div');
      note.className = 'wnw-product-note';

      const label = document.createElement('strong');
      label.textContent = 'Please note: ';

      note.appendChild(label);
      note.appendChild(document.createTextNode(noteText));

      lastInsertedElement.insertAdjacentElement('afterend', note);
    }

    description.dataset.wnwFormatted = 'true';
  }

  function runFormatter(root = document) {
    addDescriptionStyles();

    root.querySelectorAll(DESCRIPTION_SELECTOR).forEach((description) => {
      formatDescription(description);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => runFormatter());
  } else {
    runFormatter();
  }

  document.addEventListener('shopify:section:load', (event) => {
    runFormatter(event.target);
  });
})();